import { render } from "./Product.vue?vue&type=template&id=f83eb190&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=f83eb190&scoped=true&lang=css"
import "./Product.vue?vue&type=style&index=1&id=f83eb190&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f83eb190"]])

export default __exports__